import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { useForm } from 'react-hook-form';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import Invoice from 'src/components/project-billing/models/InvoiceMaster';

interface IVoidInvoiceDialogProps {
    dialogName: string;
    handleConfirm?: (invoiceNumber: string, reason: string) => void;
    hideDialog: () => void;
    invoiceNumber?: string;
    invoice?: Invoice;
    currentUser?: string;
    forDocumentArchive?: { docId: number, archiveAction: number};
}

const VoidInvoiceDialog = (props: IVoidInvoiceDialogProps) => {
    const { register, setValue, getValues, errors, handleSubmit } = useForm();
    const [reasonText, setReasonText] = useState<string>('Reason to void Invoice #:');

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (props?.forDocumentArchive) {
            setReasonText('Reason to archive document:');
        }
    }, [props?.forDocumentArchive]);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const onSubmit = () => {
        const data = getValues();
        props.handleConfirm(props?.invoiceNumber, data?.voidReason);
        props.hideDialog();
    };

    return (
        <Dialog title={props?.forDocumentArchive ? 'Archive Document' : 'Invoice Void Status'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{width: '100%'}}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'left', width: '100%'}}>
                    <label>{reasonText} {props?.forDocumentArchive ? '' : props?.invoiceNumber ?? ''}</label>
                    <RHFInputBox
                        register={register}
                        label={props?.forDocumentArchive ? 'Archive Date' : 'Void Date'}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        labelOnLeft={true}
                        name={`invoiceVoidDate`}
                        type="date"
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                        defaultVal={props?.invoice?.voided ? new Date(props?.invoice?.voidDate).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
                        readOnly={true}
                    />
                    <label>{props?.forDocumentArchive ? 'Archived by' : 'Voided by'} {props?.invoice?.voided ? props?.invoice.voidedBy : (props?.currentUser ?? '')}</label>
                    <RHFTextArea
                        setValue={setValue}
                        rules={{ required: props?.forDocumentArchive ? 'Archive reason' : 'Void reason' + ' required.' }}
                        errors={errors}
                        clearOnFirstClick={true}
                        name={`voidReason`}
                        register={register}
                        style={{width: '100%', height: '15rem', resize: 'none'}}
                        defaultValue={props?.forDocumentArchive ? 'Please enter a reason for archival...' : (props?.invoice?.voided ? props?.invoice.voidReason : 'Please enter a reason for void.')}
                    />
                </div>
                <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={props?.forDocumentArchive ? 'Archive' : (!props?.invoice?.voided ? 'Mark Void' : 'OK')}
                        type={'submit'}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => props.hideDialog()}
                    />
                </div>
            </form>
        </Dialog>
    );
};

export default VoidInvoiceDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/VoidInvoiceDialog.tsx